<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/info-icon.svg" alt="">
    </div>
    Gráficos y Estadísticas
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Informe por envase</h2>
    <a routerLink="/customer-report-home" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>
  <div class="single-page-content">
    <div class="flex justify-between items-center mb-4">
      <button class="button button-primary button-sm" (click)="toggleFilters()">
        Filtrar <i class="fa-solid" [ngClass]="showFilters ? 'fa-times' : 'fa-filter'" alt=""></i>
      </button>
      <input type="search" class="input max-w-72" placeholder="Buscar..." [(ngModel)]="filter.searchTerm" (input)="applyFilter($event)">
    </div>

    <div *ngIf="showFilters" class="grid grid-cols-1 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mb-4">
      <select class="select" [(ngModel)]="filter.containerTypeId" (ngModelChange)="applySelectFilter($event, 'containerTypeId')">
        <option [ngValue]="null">Tipo de envase</option>
        <option *ngFor="let type of containerTypes" [ngValue]="type.id">{{ type.name }}</option>
      </select>

      <select class="select" [(ngModel)]="filter.stateId" (ngModelChange)="applySelectFilter($event, 'stateId')">
        <option [ngValue]="null">Estado de envases</option>
        <option *ngFor="let status of statuses" [ngValue]="status.id">{{ status.name }}</option>
      </select>

      <select class="select" [(ngModel)]="filter.clientId" (ngModelChange)="applySelectFilter($event, 'clientId')">
        <option [ngValue]="null">Cliente</option>
        <option *ngFor="let client of clients" [ngValue]="client.id">{{ client.razonSocial }}</option>
      </select>
    </div>
    
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="nroSerie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> N° Serie </th>
        <td mat-cell *matCellDef="let data"> {{data.container.nroSerie}} </td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
        <td mat-cell *matCellDef="let data"> {{data.container.containerType.name}} </td>
      </ng-container>
      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
        <td mat-cell *matCellDef="let data"> {{data.container.client.razonSocial}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
        <td mat-cell *matCellDef="let data"> {{data.status.name || 'N/A'}} </td>
      </ng-container>
      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef> Opciones </th>
        <td mat-cell *matCellDef="let data">
          <div class="action-buttons">
            <a [routerLink]="['/container-report-general', data.container.id]" title="Ver detalle">
              <img src="assets/icons/info-icon.svg" alt="">
            </a>
            <a [routerLink]="['/timeline-container', data.container.id]" title="Ver línea de tiempo">
              <img src="assets/icons/timeline-icon.svg" alt="">
            </a>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
</div>
